export const DASHBOARD_WIDGETS = ['EXAMS', 'STORES', 'FYL', 'WISHLIST', 'ORDERS', 'BTE'] as const;
export interface IDashboardInformations {
    name: string;
    tiles: typeof DASHBOARD_WIDGETS;
}
